<script>
    import { page } from '$app/stores';

    function formatTitle(title) {
        return title
            .replace(/[^a-zA-Z0-9 ]/g, ' ') // Replace non-letter, non-digit characters with space
            .replace(/\b\w/g, (l) => l.toUpperCase()) // Capitalize all words
            .trim();
    }

    // Convert the URL path into an array of breadcrumb objects
    let pathSegments = $page.url.pathname.split('/').filter(Boolean);
    let breadcrumbs = pathSegments.map((segment, index) => {
        return {
            title: formatTitle(segment),
            url: '/' + pathSegments.slice(0, index + 1).join('/')
        };
    });
    breadcrumbs.unshift({ title: 'Home', url: '/' }); // Add 'Home' as the first breadcrumb
</script>

<nav
    aria-label="breadcrumb"
    itemscope
    itemtype="https://schema.org/BreadcrumbList"
    class="container mx-auto px-4 md:px-8 mb-4 sm:mb-8"
>
    <ol class="flex gap-2 flex-nowrap whitespace-nowrap text-ellipsis overflow-hidden">
        {#each breadcrumbs as crumb, index (index)}
            <li
                class="flex items-center gap-2"
                itemprop="itemListElement"
                itemscope
                itemtype="https://schema.org/ListItem"
            >
                <a
                    class="link"
                    href={crumb.url}
                    itemprop="item"
                >
                    <span itemprop="name">{crumb.title}</span>
                </a>
                <meta itemprop="position" content={index + 1 + ''} />
                {#if index !== breadcrumbs.length - 1}
                    <span class="opacity-50">\</span>
                {/if}
            </li>
        {/each}
    </ol>
</nav>
